import ForgetPasswordForm from "components/Organisms/login/forms/forgetPasswordForm";
import React from "react";

export default function ForgetPasswordTemplate() {
  return <ForgetPasswordForm />;
}
